/**
 * ADR-0240 Agency Portal v2 Slice 7 — shared constants for the
 * agency "Send report" dialog.
 *
 * The subject rules are duplicated across:
 *   - `services/api/src/agency/send-validators.ts` (authoritative
 *     validator)
 *   - `apps/dashboard/src/views/agency-reports/AgencyReports.tsx`
 *     (prefill)
 *
 * This module hosts the one copy both sides reference so the default
 * subject never drifts between what the dashboard pre-populates and
 * what the server accepts without a round-trip.
 *
 * Runtime export (not a type): the shape mirrors the single runtime
 * export in this package (`DEFAULT_SKILLS`).
 */
export const AGENCY_SEND_SUBJECT_MAX = 120;
export const AGENCY_SEND_FIRST_NAME_MAX = 40;
/** Default subject template — the scanned domain is the first token
 *  so it reads as a natural inbox-column anchor. Agency may edit it;
 *  the validator (`validateSendSubject` on the server) still refuses
 *  URL / HTML / all-caps / bidi content. */
export function defaultAgencySendSubject(domain) {
    return `${domain}: how ready your site is for AI agents`;
}
//# sourceMappingURL=agency-send.js.map